<template>
  <div class="user">
    <div style="background-color:#fff">
      <el-menu :default-active="activeName" class="el-menu" mode="horizontal" @select="handleSelect">
        <el-menu-item index="user">用户管理</el-menu-item>
        <el-menu-item index="device">设备管理</el-menu-item>
        <el-menu-item index="order">订单管理</el-menu-item>
        <el-menu-item index="commodity">商品管理</el-menu-item>
        <el-menu-item index="authcode">授权码管理</el-menu-item>
        <el-menu-item index='' style="float:right" @click='goback'><i class="el-icon-back"></i></el-menu-item>
      </el-menu>
    </div>
    <el-card class="card" v-if='activeName=="user"'>
      <div class="feature-container">
        <el-form :inline="true" :model="searchform" class="search-form" label-width="150px">
          <el-row>
            <el-col :span="2">
              <el-form-item>
                <el-button type="primary" @click="visible.createDialogVisible = true" size="medium">添加用户</el-button>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="单位或学校名称：">
                <el-input v-model="searchform.company" placeholder="单位或学校名称" size="medium"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="工号或学号：">
                <el-input v-model="searchform.professionid" placeholder="工号或学号" size="medium"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="手机号码：">
                <el-input v-model="searchform.tel" placeholder="手机号码" size="medium"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="2" style="padding-left:30px">
              <el-form-item>
                <el-button type="primary" @click="searchUser" size="medium">查询</el-button>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
      <div class="list-container">
        <el-table :data="userList" ref="multiple" border="" height="700">
          <el-table-column type="index" width="80" label="序号" :index="indexMethod_user"></el-table-column>
          <el-table-column prop="company" label="单位或学校"></el-table-column>
          <el-table-column prop="professionid" label="工号或学号"></el-table-column>
          <el-table-column prop="fullname" label="姓名"></el-table-column>
          <el-table-column prop="tel" label="手机号码"></el-table-column>
          <el-table-column fixed="right" label="操作" width="150">
            <template slot-scope="scope">
              <el-button @click.native.prevent="editUser(scope.$index, scope.row)" type="text" size="small">编辑</el-button>
              <el-button @click.native.prevent="delete_User(scope.$index, scope.row)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
        <el-pagination @size-change="handleSizeChange_user" @current-change="handlePageChange_user" :current-page="userTable.currentPage" :page-sizes="userTable.pageSizes" :page-size="userTable.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="userTable.total"></el-pagination>
      </div>
    </el-card>
    <el-card class="card" v-if='activeName=="device"'>
      <device></device>
    </el-card>
    <el-card class="card" v-if='activeName=="order"'>
      <order></order>
    </el-card>
    <el-card class="card" v-if='activeName=="commodity"'>
      <commodity></commodity>
    </el-card>
  <el-card class="card" v-if='activeName=="authcode"'>
     <authcode></authcode>
    </el-card>
    <el-dialog title="添加用户" :visible.sync="visible.createDialogVisible" width="26%">

      <el-form label-position="left" :model="createData" label-width="100px" :rules="validateUser" ref="CreateForm">
        <el-form-item label="单位或学校" prop="company">
          <el-input v-model="createData.company"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="fullname">
          <el-input v-model="createData.fullname"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="tel">
          <el-input v-model="createData.tel"></el-input>
        </el-form-item>
        <el-form-item label="工号/学号" prop="professionid">
          <el-input v-model="createData.professionid"></el-input>
        </el-form-item>
        <!-- <el-form-item label="设备编号" prop="androidId">
          <el-input v-model="createData.androidId"></el-input>
        </el-form-item> -->
        <el-form-item>
          <el-button @click="visible.createDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="createUser">确定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>

    <el-dialog title="编辑监督人员信息" :visible.sync="visible.updateDialogVisible" width="30%">
      <el-form label-position="left" :model="selectRow" label-width="100px" :rules="validateUser" ref="UpdateForm">
        <el-form-item label="单位或学校名称" prop="company">
          <el-input v-model="selectRow.company"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="fullname">
          <el-input v-model="selectRow.fullname"></el-input>
        </el-form-item>
        <el-form-item label="手机号码" prop="tel">
          <el-input v-model="selectRow.tel"></el-input>
        </el-form-item>
        <el-form-item label="邮箱" prop="email">
          <el-input v-model="selectRow.email"></el-input>
        </el-form-item>
        <el-form-item label="职业" prop="profession">
          <el-input v-model="selectRow.profession"></el-input>
        </el-form-item>
        <el-form-item label="工号/学号" prop="professionid">
          <el-input v-model="selectRow.professionid"></el-input>
        </el-form-item>
        <el-form-item label="设备编号" prop="androidId">
          <el-input v-model="selectRow.androidId"></el-input>
        </el-form-item>
        <el-form-item  prop="resetPassword" class="reset-password">
         <el-checkbox v-model="resetPassword">重置为默认密码</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button @click="visible.updateDialogVisible = false">取消</el-button>
          <el-button type="primary" @click="updateUser">确定</el-button>
        </el-form-item>
      </el-form>

    </el-dialog>
  </div>

</template>

<script>
import order from './Order.vue'
import device from './Device.vue'
import commodity from './Commodity.vue'
import authcode from './Authcode'

export default {
  name: 'user',
  data () {
    return {
      activeName: 'user',
      searchform: {
      },
      userList: [],
      userTable: {
        total: 0,
        pageSizes: [10, 20, 50],
        pageSize: 20,
        currentPage: 1
      },
      visible: {
        createDialogVisible: false,
        updateDialogVisible: false
      },
      validateUser: {
        company: [{
          required: true, message: '请输入单位或学校名称'
        }],
        tel: [{
          required: true, message: '请输入手机号码'
        }],
        androidId: [{
          required: true, message: '请输入设备编号'
        }]
      },
      createData: {},
      selectRow: {
        // resetPassword:false

      },
      resetPassword: false
    }
  },
  components: {
    order,
    commodity,
    device,
    authcode
  },
  created: async function () {
    var res = await this.$$getUserList(this.userTable.currentPage, this.userTable.pageSize)
    this.userList = res.list
    this.userTable.total = res.total
  },
  methods: {
    handleSelect (val) {
      this.activeName = val
    },
    goback () {
      this.$store.dispatch('remove_remember')
      this.$store.dispatch('remove_userinfo')
      this.$router.push({ path: '/login' })
    },
    searchUser () {
      if (Object.keys(this.searchform).length === 0) {
        this.$message.error('关键字不能为空')
        return
      }
      this.userTable.currentPage = 1
      this.refreshUserList()
    },
    refreshUserList: async function () {
      this.searchform.page = this.userTable.currentPage
      this.searchform.size = this.userTable.pageSize
      var res = await this.$$searchUserList(this.searchform)
      this.userTable.total = res.total
      this.userList = res.list
    },
    /**
               * 分页操作
               */
    handleSizeChange_user (val) {
      this.userTable.pageSize = val
      this.refreshUserList()
    },
    handlePageChange_user (val) {
      this.userTable.currentPage = val
      this.refreshUserList()
    },
    indexMethod_user (index) {
      return index + 1 + this.userTable.pageSize * (this.userTable.currentPage - 1)
    },

    createUser () {
      this.$refs.CreateForm.validate(async valid => {
        if (valid) {
          var res = await this.$$postUser({ user: this.createData, from: 'admin' })
          if (res) {
            this.refreshUserList()
            this.visible.createDialogVisible = false
          }
        }
      })
    },
    editUser (index, row) {
      this.selectRow = JSON.parse(JSON.stringify(row))
      this.resetPassword = false
      this.visible.updateDialogVisible = true
    },
    updateUser () {
      this.$refs.UpdateForm.validate(async valid => {
        if (valid) {
          // delete this.selectRow.uid;
          // this.selectRow.password = '123456abcde';
          // var res = await this.$$postUser(this.selectRow);
          delete this.selectRow.password
          var res = await this.$$updateUser({ user: this.selectRow, from: 'admin', resetPassword: this.resetPassword })
          if (res) {
            this.refreshUserList()
            this.visible.updateDialogVisible = false
          }
        }
      })
    },
    delete_User (index, row) {
      this.$confirm('此操作将永久删除该信息, 是否继续?', '删除', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        await this.$$deleteUser(row.uid).then(() => {
          this.$message.success('删除成功！')
          this.refreshUserList()
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    }
  }
}
</script>

<style scoped>
.user {
    height: 100%;
    padding: 24px;
    box-sizing: border-box;
    background-color: rgb(240,242,245);
}
.feature-container {
    margin: 20px;
    background-color: #ffffff;
}
.list-container {
    margin: 20px;
}
.card{
    margin-top: 24px;
}
.reset-pass {
  text-align: left;
}
</style>
